import { isPlatformBrowser } from '@angular/common';
/*
@Input()
travelType = Type of date UI display(while using in flight search page)(Departure/Return/Dates)
legendtext = Lagend Test for travelType "Date" display
labelText = Label for field / multicity use only
departlabelText = Label for depart
returnlabelText = Label for return
checkJourneyType = Required to render different template, Type of journey MULTICITY or Other Types(else by default)
connectionText = Conneting ariport label
dateFor = form field ID for label and dynamic suffix for multi row creation
travelDateForm = Form Object name to display/preselect
*/
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgcCalendarDirective } from '../calendar.directive';

declare let delta: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'date-selection-view',
  templateUrl: './date-selection.component.html'
})
export class DateSelectionComponent implements OnInit, OnDestroy {
  viewportWidth: number;
  @Input() travelType: string;
  @Input() labelText = '';
  @Input() departlabelText: string;
  @Input() returnlabelText: string;
  @Input() dateFor: string;
  @Input() checkJourneyType: string;
  @Input() connectionText: string;
  @Input() submitted: boolean;
  @Input() index: number;
  @Input() fieldName: string;
  @Input() labelClass = '';
  @Input() calendarClass = '';

  @Input() public formObj: UntypedFormGroup;

  // tslint:disable-next-line:no-input-rename
  @Input('formObject') public travelDateForm: UntypedFormGroup;

  @Input() departPlaceHolderText: string;
  @Input() returnPlaceHolderText: string;
  @Input() standaloneCal = 'false';
  @Input() isFlexDates = 'false';
  @Input() isFlexDatesDisabled = 'false';
  @Input() isFlexDatesDisabledByEdoc = 'false';

  @Input() floatingLbl: string;

  @Input() showDateFormat: string;
  @Input() displayDateFormat: string;

  @Input() allowPreviousDay: number;
  @Input() showDefaultDate: boolean;
  @Input() defaultDepartDate: string;
  @Input() defaultReturnDate: string;
  @Input() firstElement: string;
  @Input() allowDay = 331;

  @Output() inputFocus = new EventEmitter<any>();
  @Output() inputBlur = new EventEmitter<any>();
  @Output() inputClick = new EventEmitter<any>();

  @ViewChild('calendarDir') calendarDir: NgcCalendarDirective;

  showAirportLookup: boolean;
  focusedElem: string;
  inputCustomClass: string;
  validationErrors: Array<object>;
  public deviceTypes: any = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdf: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && document && window) {
      const width = this.getWidth();
      this.viewportWidth = width;
    }
  }

  getWidth() {
    return Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (isPlatformBrowser(this.platformId) && document && window) {
      const width = this.getWidth();
      this.viewportWidth = width;
      this.cdf.detectChanges();
    }
  }

  inputFocusEmit(event) {
    this.inputFocus.emit(event);
  }

  inputBlurEmit(event) {
    this.inputBlur.emit(event);
    this.updateMultiCityDate();
  }

  inputClickEmit(event) {
    this.inputClick.emit(event);
    this.updateMultiCityDate();
  }

  public updateMultiCityDate() {
    if (
      this.travelType === 'Multicity' &&
      this.focusedElem === 'departureDate'
    ) {
      const segmentControl = this.formObj.controls['segments']['controls'];
      if (segmentControl.length > this.index - 1) {
        this.setDepartureDate(segmentControl);
      }
    }
  }

  setDepartureDate(segmentControl) {
    if (segmentControl[this.index]) {
      segmentControl[this.index]['controls'].departureDate.setValue(
        segmentControl[this.index - 1]['controls'].departureDate.value,
        { onlySelf: true }
      );
    }
  }

  ngOnDestroy() {
    this.cdf.detach();
  }

  resetCalendar() {
    this.calendarDir.resetViewCalendar();
  }
}
